import ROUTER from '@/shared/config/routes'
import UiButton from '@/shared/ui/ui-button'
import UiResult from '@/shared/ui/ui-result'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

const messageOf = (error: unknown): string => {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`
  if (error instanceof Error) return error.message
  return 'Lỗi không xác định'
}

// Trình duyệt khác nhau báo lỗi tải chunk bằng thông điệp khác nhau
const CHUNK_ERROR = /dynamically imported module|Importing a module script failed/i

export default function RouteErrorPage() {
  const error = useRouteError()
  if (error instanceof Error && CHUNK_ERROR.test(error.message)) {
    return (
      <UiResult
        status="error"
        title="Đã xảy ra lỗi"
        subTitle="Ứng dụng có phiên bản mới. Vui lòng tải lại trang."
        extra={
          <UiButton type="primary" onClick={() => window.location.reload()}>
            Tải lại trang
          </UiButton>
        }
      />
    )
  }
  return (
    <UiResult
      status="error"
      title="Đã xảy ra lỗi"
      subTitle={messageOf(error)}
      extra={
        // href (tải lại trang) có chủ ý: sau lỗi render, state trong bộ nhớ có thể đã hỏng
        <UiButton type="primary" href={ROUTER.HOME}>
          Về trang chủ
        </UiButton>
      }
    />
  )
}
